var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8204 12.0537C10.4504 12.0537 9.13651 11.5241 8.16776 10.5814C7.19902 9.63867 6.65479 8.36007 6.65479 7.02686C6.65479 5.69366 7.19902 4.41505 8.16776 3.47233C9.13651 2.52961 10.4504 2 11.8204 2C13.1904 2 14.5043 2.52961 15.4731 3.47233C16.4418 4.41505 16.9861 5.69366 16.9861 7.02686C16.9861 8.36007 16.4418 9.63867 15.4731 10.5814C14.5043 11.5241 13.1904 12.0537 11.8204 12.0537Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4873 25.4582V23.7826C1.4873 22.005 2.21295 20.3002 3.50461 19.0433C4.79627 17.7863 6.54813 17.0801 8.37481 17.0801H15.2623C17.089 17.0801 18.8409 17.7863 20.1325 19.0433C21.4242 20.3002 22.1498 22.005 22.1498 23.7826V25.4582",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileTop);
export default __webpack_public_path__ + "static/media/profile_top.5fb7a1a377e82f753062c4c29207e8ad.svg";
export { ForwardRef as ReactComponent };